import { useEffect } from 'react';
import axios from 'axios';
import { useQueryClient } from 'react-query';
import useCurrentUser from './useCurrentUser';

const apiUrl = () => process.env.REACT_APP_BASIX_API || '';
const THROTTLE_KEY = 'basix:auto-reconcile-at';
const THROTTLE_MS = 10 * 60_000;

// item 1136 (Chad: "can stripe auto reconcile when the sub page / accountant / project /
// collections is opened?") — fire the item-1037 reconcile sweep automatically when a money
// surface mounts, at most once per 10 minutes per browser session (the sweep makes ~a call
// per sub/invoice to Stripe — a throttle keeps casual navigation from hammering it). Admins/
// accountants only (the endpoint is gated); silent best-effort, then the ledgers refresh so
// healed charges/payments appear without a manual reload.
const useAutoReconcile = (): void => {
  const { isAdmin } = useCurrentUser();
  const qc = useQueryClient();
  useEffect(() => {
    if (!isAdmin) return;
    try {
      const last = Number(window.sessionStorage.getItem(THROTTLE_KEY) || 0);
      if (Date.now() - last < THROTTLE_MS) return;
      window.sessionStorage.setItem(THROTTLE_KEY, String(Date.now()));
    } catch { /* no storage — fire anyway, the server survives */ }
    axios.post(`${apiUrl()}payment/reconcile`, {})
      .then(() => {
        qc.invalidateQueries('subscriptionCharges');
        qc.invalidateQueries('invoices');
        qc.invalidateQueries('recurringRevenue');
      })
      .catch(() => { /* best-effort — the manual Reconcile button remains the loud path */ });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin]);
};

export default useAutoReconcile;
